"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryInfoPanel = void 0;
var deliveryInfoWLS_cms_1 = require("../components/panels/DeliveryInfoWLS/deliveryInfoWLS.cms");
var deliveryInfoPanel_cms_1 = require("../components/panels/DeliveryInfoPanel/deliveryInfoPanel.cms");
var ShippingMethodCard_cms_1 = require("../components/cards/ShippingMethodsCard/ShippingMethodCard.cms");
var TimeSelectionPopup_cms_1 = require("../components/panels/DeliveryInfoWLS/SameDay/TimeSelectionPopup.cms");
var HylaTradeInReturn_cms_1 = require("../components/panels/DeliveryInfoWLS/HylaTradeInReturn/HylaTradeInReturn.cms");
var DeliveryInfoPanel = /** @class */ (function () {
    function DeliveryInfoPanel() {
        this.WLSDelivery = new deliveryInfoWLS_cms_1.DeliveryInfoWLSCms();
        this.DTVNOWDelivery = new deliveryInfoPanel_cms_1.DeliveryInfoPanelCms();
        this.shippingMethod = new ShippingMethodCard_cms_1.ShippingMethodCardCms();
        this.timeSelectionPopup = new TimeSelectionPopup_cms_1.TimeSelectionPopupCms();
        this.hylaTradeInReturn = new HylaTradeInReturn_cms_1.HylaTradeInReturnCms();
    }
    return DeliveryInfoPanel;
}());
exports.DeliveryInfoPanel = DeliveryInfoPanel;
//# sourceMappingURL=DeliveryPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/DeliveryPanel.cms.js
// module id = 1988
// module chunks = 8